// (A) 중립 Card API — antd 미접촉. (B) PlainCard 에 위임.
import type { CSSProperties, ReactNode } from 'react'
import { PlainCard } from '../_impl/PlainCard'

export interface OmwCardProps {
  /** 실측: propsUI 가 title 컨테이너로 사용. */
  title?: ReactNode
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export function OmwCard(props: OmwCardProps) {
  return <PlainCard {...props} />
}
